<template>
  <div>
     <div v-html="HeaderStatusHtmlText"></div>
  </div>
</template>

<script>
export default {
  props: {
    HeaderStatusHtmlText: {
      type: String,
      default: ''
    }
  }
}
</script>

<style>

</style>